import script from "./supplement-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-editor.vue?vue&type=script&setup=true&lang=js"

import "./supplement-editor.vue?vue&type=style&index=0&id=7cfe79e4&lang=scss"
import "./supplement-editor.vue?vue&type=style&index=1&id=7cfe79e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cfe79e4"]])

export default __exports__